export default "__VITE_ASSET__mppToclO__"